import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header5 from "../../components/header/Header5";
import Footer3 from "../../components/footer3";
import Gotop from "../../components/gotop";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumb from "../../components/breadcrumb";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import defaultPic from "../../assets/siteimages/favicon.png"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

DashboardAstrologer.propTypes = {};

function DashboardAstrologer(props) {

  const [tabIndex, setTabIndex] = useState(0);



  

  // ------- Profile form state & validation -------
  const [initialFormData, setInitialFormData] = useState({});
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contactNo: "",
    gender: "",
    dob: ""
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    let newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required.";
    if (!formData.dob || !formData.dob.trim()) newErrors.dob = "Date Of Birth is required.";
    if (!formData.gender || !formData.gender.trim()) newErrors.gender = "Gender is required.";
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid Email is required.";
    if (!/^[6-9]\d{9}$/.test(formData.contactNo))
      newErrors.contactNo = "Enter a valid 10-digit Indian mobile number.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contactNo") {
      if (!/^\d*$/.test(value)) return; // only digits
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    let newErrors = { ...errors };
    if (!value) {
      newErrors[name] = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    } else {
      delete newErrors[name];
    }
    setErrors(newErrors);
  };

  // ------- Auth / astrologer id -------
  const [astrologerId, setAstrologerId] = useState(null);
  useEffect(() => {
    const storedUserId = localStorage.getItem("astrologerId");
    if (storedUserId) setAstrologerId(storedUserId);
  }, []);

  // ------- Astrologer status & Ctype -------
  const [astrologerStatus, setAstrologerStatus] = useState({ Vemail: "1", Vnumber: "1", Regstatus: "1" });
  const [astrologerStatusnew, setAstrologerStatusnew] = useState({ Astatus: "Active" });
  const [astrologerCtype, setAstrologerCtype] = useState(""); // used to show Manage Slots button

  useEffect(() => {
    const fetchAstrologerStatus = async () => {
      try {
        if (!astrologerId) return;
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getastrologerbyidnew/${astrologerId}`);
        if (response.data) {
          setAstrologerStatus({
            Vemail: response.data.Vemail,
            Vnumber: response.data.Vnumber,
            Alanguages: response.data.Alanguages,
            Aservices: response.data.Aservices,
            Aphotograph: response.data.Aphotograph,
            Named: response.data.Named,
            Path1: response.data.Path1,
          });
        }
      } catch (error) {
        console.error("Error fetching astrologer status:", error);
      }
    };

    const fetchAstrologerStatusnew = async () => {
      try {
        if (!astrologerId) return;
        const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getastrologerbyidnewlatest/${astrologerId}`);
        if (response.data) {
          setAstrologerStatusnew({ Astatus: response.data.Astatus });
        }
      } catch (error) {
        console.error("Error fetching astrologer status latest:", error);
      }
    };

    const fetchBasicProfile = async () => {
  try {
    if (!astrologerId) return;
    const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getastrologerbyid/${astrologerId}`);
    if (response.data) {
      const userData = {
        fullName: response.data.Named || "",
        email: response.data.Email || "",
        contactNo: response.data.Cno || "",
        gender: response.data.Gender || "",
        dob: response.data.Dob || ""
      };
      setFormData(userData);
      setInitialFormData(userData);

      // NORMALIZE Ctype (trim + lowercase) to avoid casing/whitespace issues
      const rawCtype = response.data.Ctype ?? response.data.CTYPE ?? response.data.ctype ?? "";
      const normCtype = (typeof rawCtype === "string") ? rawCtype.trim().toLowerCase() : "";
      setAstrologerCtype(normCtype);

      // DEBUG: quick console log to verify what arrives
      console.log("fetchBasicProfile: rawCtype=", rawCtype, " -> normCtype=", normCtype);
    }
  } catch (error) {
    console.error("Error fetching basic profile:", error);
  }
};

    fetchAstrologerStatus();
    fetchAstrologerStatusnew();
    fetchBasicProfile();
  }, [astrologerId]);

  const imageSrc = astrologerStatus.Path1 ? astrologerStatus.Path1 : defaultPic;

  // ------- Form submission -------
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsSubmitting(true);
    const updatedData = { ...formData, astrologerId };
    try {
      const response = await axios.post(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/updateastrologerprofile",
        updatedData,
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success(response.data.message || "Profile updated");
      // update initial snapshot so "hasChanges" toggles off
      setInitialFormData(formData);
      // optional redirect after short pause:
      setTimeout(() => {
        window.location.href = "/astrologerdashboard";
      }, 1500);
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  const hasChanges = JSON.stringify(formData) !== JSON.stringify(initialFormData);

  // ------- NEW: Appointments table (booking_details where AstrologerId = astrologerId) -------
  const [appointments, setAppointments] = useState([]);
  const [appointmentsLoading, setAppointmentsLoading] = useState(false);

  useEffect(() => {
    const fetchAppointments = async () => {
      if (!astrologerId) return;
      setAppointmentsLoading(true);
      try {
        // adjust endpoint if your backend uses different route
        const endpoint = `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getbookingsbyastrologer/${astrologerId}`;
        const resp = await axios.get(endpoint);

        if (Array.isArray(resp.data)) {
          const normalized = resp.data.map((b) => ({
            raw: b,
            bookingId: b.BookingId || b.Id || b.booking_id || b.id || "",
            clientName: b.Cname || b.ClientName || b.Name || b.CustName || "",
            date: b.Bdate || b.booking_date || b.Date || b.bookingDate || "",
            time: b.Btime || b.Time || b.slot_time || b.Slot || "",
            amount: b.Amount || b.Price || b.Courserice || "",
            status: b.Status || b.Pstatus || b.booking_status || ""
          }));
          setAppointments(normalized);
        } else if (Array.isArray(resp.data.data)) {
          setAppointments(resp.data.data);
        } else {
          console.warn("Unexpected bookings response:", resp.data);
          setAppointments([]);
        }
      } catch (err) {
        console.error("Error fetching appointments:", err);
        setAppointments([]);
      } finally {
        setAppointmentsLoading(false);
      }
    };

    fetchAppointments();
  }, [astrologerId]);

  const { logout } = useContext(AuthContext);

  return (
    <>
      <Helmet>
        <title>Your Dashboard - Adhigyanam | Sauntesthyam LLP</title>
      </Helmet>

    
      <Breadcrumb title="Dashboard" />

      <section className="account-section" style={{ padding: "30px 0px 0px" }}>
        <div className="tf-container">
          <div className="row" style={{ textAlign: "center", marginBottom: 0 }}>
            <h5 style={{ marginBottom: 0, fontSize: 27 }}>Welcome, {astrologerStatus.Named}</h5>
            <p style={{ maxWidth: 900, margin: "auto", padding: "auto" }}>
              Use the following form and features to manage your profile and access your bookings, appointments and more.
            </p>
          </div>

          <div style={{ textAlign: "center", maxWidth: 300, margin: "auto", marginTop: 20 }}>
            <img
              src={imageSrc}
              alt="Astrologer"
              style={{ width: 100, height: 100, borderRadius: "50%", padding: 5, border: "solid #f2f2f2 2px" }}
            /><br />
            <NavLink style={{ marginTop: 10, color: "rgb(20, 160, 119)", fontWeight: "bold" }} to="/change-photo">Change Profile Pic</NavLink>
          </div>
        </div>
      </section>

      <section className="checkout-section" style={{ paddingTop: "30px", paddingBottom: "0px" }}>
        <div className="tf-container">

<Tabs selectedIndex={tabIndex} onSelect={(i) => setTabIndex(i)}>
  <TabList
    style={{
      display: "flex",
      justifyContent: "center",
      gap: 24,
      marginBottom: 20,
      borderBottom: "1px solid #e5e7eb",
    }}
  >
    <Tab
      style={{
        padding: "12px 30px",
        fontSize: 14,
        fontWeight: 700,
        cursor: "pointer",
        color: tabIndex === 0 ? "#0f766e" : "#6b7280",
        borderBottom: tabIndex === 0 ? "3px solid #0f766e" : "3px solid transparent",
      }}
    >
      Account
    </Tab>

    <Tab
      style={{
        padding: "12px 30px",
        fontSize: 14,
        fontWeight: 700,
        cursor: "pointer",
        color: tabIndex === 1 ? "#0f766e" : "#6b7280",
        borderBottom: tabIndex === 1 ? "3px solid #0f766e" : "3px solid transparent",
      }}
    >
      Appointments
    </Tab>
  </TabList>
<TabPanel>
  <div>
            <div className="row" style={{ maxWidth: 1200, margin: "auto", padding: "auto" }}>
              <div className="col-lg-12">
                <div className="form-candidate form-checkout form-stc">
                  <div className="group-title">
                    <h6 style={{ textAlign: "left", fontSize: "22px", marginBottom: "5px" }}>Manage Your Account</h6>
                    <p style={{ textAlign: "left" }}><b>Why is this important?</b> To serve you better and to provide you with accurate tailored solutions we request you to please complete your profile before proceeding.</p>
                  </div>

                  <form onSubmit={handleSubmit} style={{ textAlign: "left" }}>
                    <div className="group-input" style={{ marginBottom: "0px" }}>
                      <div className="ip" style={{ marginBottom: "15px" }}>
                        <label style={{ float: "left", fontWeight: "bold" }}>Full Name</label>
                        <input type="text" name="fullName"
                          value={formData.fullName}
                          onChange={handleChange}
                          placeholder="Full Name" style={{ backgroundColor: "#fafafa", color: "black" }} />
                        {errors.fullName && <p className="error">{errors.fullName}</p>}
                      </div>

                      <div className="ip" style={{ marginBottom: "15px" }}>
                        <label style={{ float: "left", fontWeight: "bold" }}>Date Of Birth</label>
                        <input type="date" name="dob"
                          value={formData.dob}
                          onChange={handleChange}
                          placeholder="Date Of Birth" style={{ backgroundColor: "#fafafa", color: "black" }} />
                        {errors.dob && <p className="error">{errors.dob}</p>}
                      </div>

                      <div className="ip" style={{ marginBottom: "15px" }}>
                        <label style={{ float: "left", fontWeight: "bold" }}>Gender</label>
                        <select
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={errors.gender ? "input-error" : ""}
                          style={{ backgroundColor: "#fafafa", color: "black" }}
                        >
                          <option value="">Select Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Prefer Not To Say</option>
                        </select>
                        {errors.gender && <span className="error-message">{errors.gender}</span>}
                      </div>

                      <div className="ip" style={{ marginBottom: "15px" }}>
                        <label style={{ float: "left", fontWeight: "bold" }}>IN Contact No.</label>
                        <input type="text" name="contactNo"
                          value={formData.contactNo}
                          onChange={handleChange}
                          inputMode="numeric"
                          pattern="\d*"
                          maxLength="10"
                          placeholder="Contact No." style={{ backgroundColor: "whitesmoke" }} disabled />
                        {errors.contactNo && <p className="error">{errors.contactNo}</p>}
                      </div>

                      <div className="ip" style={{ marginBottom: "15px" }}>
                        <label style={{ float: "left", fontWeight: "bold" }}>Email Address</label>
                        <input type="text" name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email Address" style={{ backgroundColor: "whitesmoke" }} disabled />
                        {errors.email && <p className="error">{errors.email}</p>}
                      </div>
                    </div>

                    <div className="group-input-st1">
                      <button
                        type="submit"
                        disabled={!hasChanges || isSubmitting}
                        style={{
                          cursor: !hasChanges || isSubmitting ? "not-allowed" : "pointer",
                          opacity: !hasChanges || isSubmitting ? 0.6 : 1
                        }}
                      >
                        {isSubmitting ? "Please Wait..." : "Update Details"}
                      </button>
                    </div>
                  </form>

                  <style>
                    {`
                      .Toastify__close-button { display: none; }
                      .Toastify__toast { position: relative; padding-right: 30px; }
                    `}
                  </style>

                  <ToastContainer position="bottom-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover />
                </div>
              </div>
            </div>
             {/* ---------- Appointments section (styled) ---------- */}

          </div>
</TabPanel>
<TabPanel>
 <div className="row" style={{ maxWidth: 1200, margin: "auto", padding: "auto", marginBottom: 30 }}>
              <div className="col-lg-12">
  <div
    style={{
      width: "100%",
      background: "#fff",
      borderRadius: 12,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      padding: 20,
      fontFamily: "Inter, sans-serif",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 15,
      }}
    >
      <p style={{ margin: 0, color: "#222", fontSize: 18, fontWeight: 600, lineHeight: "22px" }}>
        eConsultation Appointments<br/> <span style={{fontSize:"14px", fontWeight:"normal"}}>Total Bookings: {appointments.length}</span>
      </p>
      <span style={{ color: "#999", fontSize: 13, fontWeight: 600 }}>
       {/* Manage / Create Slots button — only shown for Contractual astrologers */}
    {(astrologerCtype === "contractual") && (
      <NavLink to="/astrologerslots" style={{ textDecoration: "none" }}>
        <button
          type="button"
          style={{
            padding: "12px 12px",
            background: "#14A077",
            color: "#fff",
            borderRadius: 8,
            border: "none",
            fontWeight: 800,
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(20,160,119,0.15)"
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 0.92)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 1)}
        >
          Time Slots
        </button>
      </NavLink>
    )}
       
      </span>

     
    </div>

  <div
  style={{
    width: "100%",
  }}
>
  {appointmentsLoading ? (
    <div
      style={{
        textAlign: "center",
        padding: "30px 15px",
        fontSize: 14,
        color: "#777",
      }}
    >
      Loading appointments...
    </div>
  ) : appointments.length === 0 ? (
    <div
      style={{
        textAlign: "center",
        padding: "30px 15px",
        fontSize: 14,
        color: "#777",
        background: "#fafafa",
        borderRadius: 10,
        border: "1px solid #eeeeee",
      }}
    >
      No appointments were found.
    </div>
  ) : (
    <>
      <style>
        {`
          .appointments-grid {
            display: grid;
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: 18px;
          }

          .appointment-card {
            background: #ffffff;
            border: 1px solid #e8e8e8;
            border-radius: 12px;
            padding: 18px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.06);
            transition: all 0.2s ease;
            display: flex;
            flex-direction: column;
            min-height: 245px;
          }

          .appointment-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 18px rgba(0,0,0,0.10);
            border-color: #d9e9e5;
          }

          .appointment-card-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 10px;
            margin-bottom: 15px;
          }

          .appointment-booking-id {
            font-size: 15px;
            font-weight: 700;
            color: #111827;
          }

          .appointment-status {
            font-size: 11px;
            font-weight: 700;
            padding: 5px 9px;
            border-radius: 20px;
            background: #fff7ed;
            color: #f97316;
            white-space: nowrap;
          }

          .appointment-info {
            display: flex;
            flex-direction: column;
            gap: 12px;
            flex: 1;
          }

          .appointment-info-row {
            display: flex;
            flex-direction: column;
            gap: 3px;
          }

          .appointment-label {
            font-size: 11px;
            font-weight: 700;
            color: #9ca3af;
            text-transform: uppercase;
            letter-spacing: 0.4px;
          }

          .appointment-value {
            font-size: 13px;
            font-weight: 600;
            color: #374151;
            word-break: break-word;
          }

          .appointment-action {
            display: block;
            width: 100%;
            text-align: center;
            padding: 9px 12px;
            margin-top: 16px;
            background: #0a66c2;
            color: #ffffff;
            border-radius: 7px;
            text-decoration: none;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.2px;
            transition: background 0.2s ease;
          }

          .appointment-action:hover {
            background: #084b8a;
            color: #ffffff;
          }

          @media (max-width: 991px) {
            .appointments-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }
          }

          @media (max-width: 575px) {
            .appointments-grid {
              grid-template-columns: 1fr;
              gap: 14px;
            }

            .appointment-card {
              min-height: auto;
            }
          }
        `}
      </style>

      <div className="appointments-grid">
        {appointments.map((row, idx) => {
          // Booking ID
          const bookingId =
            row.BookingId ||
            row.bookingId ||
            row.raw?.BookingId ||
            row.raw?.bookingId;

          // Category
          const category =
            row.Category ||
            row.raw?.Category ||
            "-";

          // Price
          const priceVal =
            row.TotalPrice ??
            row.raw?.TotalPrice ??
            row.amount ??
            0;

          const priceFormatted = new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 2,
          }).format(Number(priceVal || 0));

          // Booking date
          const bookingDateRaw =
            row.BookingDate ||
            row.raw?.BookingDate ||
            row.date ||
            row.raw?.Bdate;

          const bookingDate = bookingDateRaw
            ? new Date(bookingDateRaw).toLocaleString()
            : "-";

          // Status
          const status =
            row.Status ||
            row.raw?.Status ||
            row.status ||
            row.raw?.Pstatus ||
            "-";

          return (
            <div
              className="appointment-card"
              key={bookingId || idx}
            >
              {/* Card Header */}
              <div className="appointment-card-header">
                <div className="appointment-booking-id">
                  #{bookingId || "-"}
                </div>

                <div className="appointment-status">
                  {status}
                </div>
              </div>

              {/* Appointment Details */}
              <div className="appointment-info">

                <div className="appointment-info-row">
                  <span className="appointment-label">
                    Category
                  </span>

                  <span className="appointment-value">
                    {category}
                  </span>
                </div>

                <div className="appointment-info-row">
                  <span className="appointment-label">
                    Booking Date
                  </span>

                  <span className="appointment-value">
                    {bookingDate}
                  </span>
                </div>

                {/* Price currently hidden in your table,
                    so keeping it hidden here as well */}
                {/*
                <div className="appointment-info-row">
                  <span className="appointment-label">
                    Amount
                  </span>

                  <span className="appointment-value">
                    {priceFormatted}
                  </span>
                </div>
                */}

              </div>

              {/* Action */}
              <Link
                to={`/astroappointments/${bookingId}`}
                className="appointment-action"
              >
                View Appointment
              </Link>
            </div>
          );
        })}
      </div>
    </>
  )}
</div>
  </div>
</div></div>
</TabPanel>
</Tabs>








          {(astrologerStatusnew.Astatus === "Suspended" || astrologerStatusnew.Astatus === "Deactivated") && (
            <div style={{}}>
              <div className="row" style={{ maxWidth: 1200, margin: "auto", padding: "auto", textAlign: "center", paddingTop: 20, borderRadius: 5, marginBottom: 15, backgroundColor: "whitesmoke", border: "solid red 2px" }}>
                <div className="col-lg-12">
                  <div className="form-candidate form-checkout form-stc">
                    <div className="group-title">
                      <p style={{ textAlign: "left" }}><b>ALERT: Your Account has been Suspended or Deactivated!</b><br />Your account was suspended / permanently deactivated due to company policy violations. You are no more visible on the Adhigyanam network. In case of any queries or account rectifications kindly contact <NavLink to="/support" style={{ fontWeight: "bold", textDecoration: "underline" }}>Customer Support</NavLink>.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {(astrologerStatusnew.Astatus === "Inactive") && (
            <div style={{}}>
              <div className="row" style={{ maxWidth: 1200, margin: "auto", padding: "auto", textAlign: "center", paddingTop: 20, borderRadius: 5, marginBottom: 15, backgroundColor: "#EFFBEF" }}>
                <div className="col-lg-12">
                  <div className="form-candidate form-checkout form-stc">
                    <div className="group-title">
                      <p style={{ textAlign: "left" }}><b>IMPORTANT NOTE: Your Account is Under Review!</b><br />Your account is under Quality Control Review. Please make sure you complete your registration at the earliest.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {(astrologerStatus.Vemail === "0" || astrologerStatus.Vnumber === "0" || astrologerStatus.Alanguages === "0" || astrologerStatus.Aservices === "0" || astrologerStatus.Aphotograph === "0") && (
            <div style={{}}>
              <div className="row" style={{ maxWidth: 1200, margin: "auto", padding: "auto", textAlign: "center", paddingTop: 20, borderRadius: 5, marginBottom: 15, backgroundColor: "#FBEFF2" }}>
                <div className="col-lg-12">
                  <div className="form-candidate form-checkout form-stc">
                    <div className="group-title">
                      <p style={{ textAlign: "left" }}><b>IMPORTANT NOTE: Your Account needs attention!</b><br />Thank you for creating an account with Adhigyanam. We would like to inform that you have successfully created an account with us, but in order to make your account live we require some additional information and verifications. Please keep the following handy before requesting account activation.</p>
                      <ul style={{ textAlign: "left" }}>
                        <li><b>1. Documents required</b>: Aadhar Card, Pan Card (May be subjected to verification).</li>
                        <li><b>2. Other Requirements</b>: Professional Photograph, Language Preference & Services.</li>
                      </ul>
                      <NavLink to={`/completeprofile`} style={{ float: "right", textAlign: "right", background: "rgb(20, 160, 119)",
                        borderRadius: "4px",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "26px",
                        color: "rgb(255, 255, 255)",
                        borderColor: "transparent",
                        textTransform: "capitalize", padding: "12px 12px", marginBottom: "20px", marginRight: "35px" }}>Complete Registration</NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ---------- Profile Update Form (restored) ---------- */}
         

        

          {/* ---------- Account management footer ---------- */}
          <div
  style={{
    maxWidth: "1200px",
    margin: "30px auto",
    padding: "20px 24px",
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    flexWrap: "wrap",
  }}
>
  {/* LEFT – Info */}
  <div style={{ maxWidth: "700px" }}>
    <h6
      style={{
        fontSize: "14px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        color: "#111827",
        marginBottom: "6px",
      }}
    >
      Account Security
    </h6>

    <p
      style={{
        fontSize: "13px",
        color: "#4b5563",
        marginBottom: "8px",
        lineHeight: "1.6",
      }}
    >
      Updating your registered email address or contact number is restricted in
      accordance with Adhigyanam’s account protection and monitoring policy.
      If you still need to make changes, please{" "}
      <NavLink to="/support" style={{ textDecoration: "underline", fontWeight: 600 }}>
        Contact support
      </NavLink>.
    </p>

    <p
      style={{
        fontSize: "13px",
        color: "#4b5563",
        marginBottom: 0,
        lineHeight: "1.6",
      }}
    >
      For your safety, we recommend logging out from shared or unknown devices
      and keeping your password updated regularly.
    </p>
  </div>

  {/* RIGHT – Actions */}
  <div
    style={{
      display: "flex",
      gap: "12px",
      alignItems: "center",
      flexWrap: "wrap",
    }}
  >
    {/* Change Password */}
    <NavLink
      to={`/astrologerpassword/${astrologerId}`}
      style={{
        padding: "10px 18px",
        borderRadius: "6px",
        border: "2px solid #14a077",
        background: "#ffffff",
        fontSize: "12px",
        fontWeight: 700,
        color: "#0f766e",
        textDecoration: "none",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
      }}
    >
      Change Password
    </NavLink>

    {/* Logout */}
    <button
      onClick={logout}
      style={{
        padding: "10px 18px",
        borderRadius: "6px",
        border: "2px solid #111827",
        background: "#111827",
        color: "#ffffff",
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        cursor: "pointer",
      }}
    >
      Secure Logout
    </button>
  </div>
</div>
        </div>
      </section>

      <div
        className="floating-buttons"
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          zIndex: "1000",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <a
          href={`tel:+918960708425`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#007BFF",
            borderRadius: "50%",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaPhoneAlt />
        </a>

        <a
          href={`https://wa.me/918960708425`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#25D366",
            borderRadius: "50%",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaWhatsapp />
        </a>
      </div>

     
      <Gotop />
    </>
  );
}

export default DashboardAstrologer;